import { memo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { StripeElementsOptions, loadStripe } from "@stripe/stripe-js";
import { stripeKey } from "../../../../../firebase";
import RetryPaymentWCard from "./RetryPaymentWCard";

const stripePromise = loadStripe(stripeKey);
const RetryPaymentWCardWrapper = () => {
  return (
    <Elements
      options={
        {
          mode: "payment",
          locale: "en-AU",
          currency: "aud",

          setupFutureUsage: "on_session",
          amount: 200, //placeholder only
          // Fully customizable with appearance API.
          appearance: {
            /*...*/
          },
          payment_method_types: ["card"],
        } as StripeElementsOptions
      }
      stripe={stripePromise}
    >
      <RetryPaymentWCard />
    </Elements>
  );
};
export default memo(RetryPaymentWCardWrapper);
